// Created by create-react-app, we need to keep the file around unfortunately, deleted all code except for unregister()

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
